import React from "react";
import styles from "../styles/MobileLayout.module.scss";
import { Menu, Close } from "@mui/icons-material";
import { IconButton } from "@mui/material";
import Link from "next/link";
import { DASHBOARD } from "../constants/routes";

const MobileLayout = (props) => {
  return (
    <div className={styles.container}>
      <div>
        {props.openSidebar ? (
          <IconButton
            color="inherit"
            onClick={() => props.setOpenSidebar(false)}
            size="large"
          >
            <Close />
          </IconButton>
        ) : (
          <IconButton color="inherit" onClick={props.closeNav} size="large">
            <Menu />
          </IconButton>
        )}
      </div>
      <div className={styles.logoContainer}>
        <Link passHref href={DASHBOARD}>
          <img className={styles.logo} src={"/public-new/logo.svg"} alt="" />
        </Link>
      </div>
      <div></div>
    </div>
  );
};

export default MobileLayout;
